import React from 'react';
import { getProxyUrl } from '../../utils/image';
import { LEAGUES } from '../../constants/leagues';

function MatchStats({ match, homeTeamLogo, visitingTeamLogo }) {
  const { homeTeamName, visitingTeamName, stats } = match;

  const {
    homeCorners,
    visitingCorners,
    homeRedCards,
    visitingRedCards,
    homeYellowCards,
    visitingYellowCards,
    homeFinishes,
    visitingFinishes,
    homeShotsOnGoal,
    visitingShotsOnGoal,
  } = stats;
  return (
    <section className="col-12">
      <div className="col-12 d-flex px-sm-3 align-items-center mb-2 mb-lg-4 mt-5">
        <h2 className="heading-h6 heading-sm-h3 flex-grow-1">
          <span className="d-none d-lg-block">Statistik</span>
          <span className="d-block d-lg-none">Matchstatistik</span>
        </h2>
      </div>
      <div className="col-12">
        <div className="data-container">
          <div className="data-container__row data-container__header px-2 px-lg-3 py-2">
            <div className="row">
              <div className="col-6 col-lg-4 d-flex align-items-center gap-3">
                <img
                  height="35"
                  src={getProxyUrl(homeTeamLogo, 35, 35)}
                  alt=""
                />
                <span className="d-none d-lg-block heading-h5 text-transform-none">
                  {homeTeamName}
                </span>
              </div>
              <div className="col d-none d-lg-flex align-items-center justify-content-center heading-h5 text-transform-none gap-2 gap-lg-4">
                Matchstatistik
              </div>
              <div className="col-6 col-lg-4 d-flex align-items-center justify-content-end gap-3">
                <span className="d-none d-lg-block heading-h5 text-transform-none">
                  {visitingTeamName}
                </span>
                <img
                  height="35"
                  src={getProxyUrl(visitingTeamLogo, 35, 35)}
                  alt=""
                />
              </div>
            </div>
          </div>
          {/* <div className="row mx-0 px-2 px-lg-3 py-2 data-container__row">
            <div className="col-4 col-lg-5 d-flex align-items-center text-small text-lg-regular fw-bold pe-0">
              <div>67%</div>
              <div className="progress ms-auto" style={{ width: '67%' }} />
            </div>
            <div className="col d-flex align-items-center justify-content-center gap-3 gap-lg-4 text-small text-lg-regular fw-bold px-0">
              Bollinnehav %
            </div>
            <div className="col-4 col-lg-5 d-flex align-items-center justify-content-end text-small text-lg-regular fw-bold ps-0">
              <div className="progress" style={{ width: '33%' }} />
              <div className="ms-auto">33%</div>
            </div>
          </div> */}
          {match?.configLeagueName !== LEAGUES.FUTSAL && (
            <div className="row mx-0 px-2 px-lg-3 py-2 data-container__row">
              <div className="col-4 col-lg-5 d-flex align-items-center text-small text-lg-regular fw-bold pe-0">
                {homeFinishes}
              </div>
              <div className="col d-flex align-items-center justify-content-center gap-3 gap-lg-4 text-small text-lg-regular fw-bold px-0">
                Avslut
              </div>
              <div className="col-4 col-lg-5 d-flex align-items-center justify-content-end text-small text-lg-regular fw-bold ps-0">
                {visitingFinishes}
              </div>
            </div>
          )}
          {match?.configLeagueName !== LEAGUES.FUTSAL && (
            <div className="row mx-0 px-2 px-lg-3 py-2 data-container__row">
              <div className="col-4 col-lg-5 d-flex align-items-center text-small text-lg-regular fw-bold pe-0">
                {homeShotsOnGoal}
              </div>
              <div className="col d-flex align-items-center justify-content-center gap-3 gap-lg-4 text-small text-lg-regular fw-bold px-0">
                Avslut på mål
              </div>
              <div className="col-4 col-lg-5 d-flex align-items-center justify-content-end text-small text-lg-regular fw-bold ps-0">
                {visitingShotsOnGoal}
              </div>
            </div>
          )}
          <div className="row mx-0 px-2 px-lg-3 py-2 data-container__row">
            <div className="col-4 col-lg-5 d-flex align-items-center text-small text-lg-regular fw-bold pe-0">
              {homeYellowCards}
            </div>
            <div className="col d-flex align-items-center justify-content-center gap-3 gap-lg-4 text-small text-lg-regular fw-bold px-0">
              Gula kort
            </div>
            <div className="col-4 col-lg-5 d-flex align-items-center justify-content-end text-small text-lg-regular fw-bold ps-0">
              {visitingYellowCards}
            </div>
          </div>
          <div className="row mx-0 px-2 px-lg-3 py-2 data-container__row">
            <div className="col-4 col-lg-5 d-flex align-items-center text-small text-lg-regular fw-bold pe-0">
              {homeRedCards}
            </div>
            <div className="col d-flex align-items-center justify-content-center gap-3 gap-lg-4 text-small text-lg-regular fw-bold px-0">
              Röda kort
            </div>
            <div className="col-4 col-lg-5 d-flex align-items-center justify-content-end text-small text-lg-regular fw-bold ps-0">
              {visitingRedCards}
            </div>
          </div>
          {match?.configLeagueName !== LEAGUES.FUTSAL && (
            <div className="row mx-0 px-2 px-lg-3 py-2 data-container__row">
              <div className="col-4 col-lg-5 d-flex align-items-center text-small text-lg-regular fw-bold pe-0">
                {homeCorners}
              </div>
              <div className="col d-flex align-items-center justify-content-center gap-3 gap-lg-4 text-small text-lg-regular fw-bold px-0">
                Hörnor
              </div>
              <div className="col-4 col-lg-5 d-flex align-items-center justify-content-end text-small text-lg-regular fw-bold ps-0">
                {visitingCorners}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default MatchStats;
